module.exports = __webpack_public_path__ + "img/max15.9eee5045.png";